// Live's card selection (#668, spec docs/specs/web/S1c-library-move-bulk.md): the files checked
// in the list on screen. A selection belongs to one view of the list: another folder, filter,
// search, order or the trash starts it empty, as live's page does, without an effect to reset it.
import { useState } from "react";

const NONE: ReadonlySet<string> = new Set();

export interface Selection {
  ids: ReadonlySet<string>;
  toggle: (id: string) => void;
  clear: () => void;
}

/** The checked file ids of `view`, a key of what the list shows. */
export function useSelection(view: string): Selection {
  const [state, setState] = useState<{ view: string; ids: ReadonlySet<string> }>({
    view,
    ids: NONE,
  });
  const ids = state.view === view ? state.ids : NONE;
  return {
    ids,
    toggle: (id) =>
      setState((current) => {
        const next = new Set(current.view === view ? current.ids : NONE);
        if (next.has(id)) next.delete(id);
        else next.add(id);
        return { view, ids: next };
      }),
    clear: () => setState({ view, ids: NONE }),
  };
}
